// extracted by mini-css-extract-plugin
export default {"card-wrapper":"FontCard_card-wrapper__hZYGP","card-inner-wrapper":"FontCard_card-inner-wrapper__E7YUl","font-family-wrapper":"FontCard_font-family-wrapper__PehEn"};